{
  "roleId": "role-310000-mfrs",
  "roleUri": "http://xbrl.ssm.com.my/role/ssm/rol_ssmt-fs-mfrs_2022-12-31/ssmt-fs-mfrs_2022-12-31_role-310000",
  "label": "[310000] Statement of profit or loss, by function of expense (MFRS)",
  "taxonomy": "FS-MFRS",
  "sheetId": "StatementOfProfitOrLossByFunction",
  "description": "Statement of profit or loss using classification by function of expense method - MFRS",
  "controls": [
    {
      "qname": "ssmt:DisclosureOnStatementOfProfitOrLossByFunctionAbstract",
      "label": "Statement of Profit or Loss",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 1,
        "dualColumn": true
      }
    },
    {
      "qname": "ssmt-mpers:ContinuingOperationsAbstract",
      "label": "Continuing operations",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:Revenue",
      "label": "Revenue",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-full:Revenue"
        }
      }
    },
    {
      "qname": "ifrs-full:CostOfSales",
      "label": "(-) Cost of sales",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-full:CostOfSales"
        }
      }
    },
    {
      "qname": "ifrs-full:GrossProfit",
      "required": true,
      "label": "Gross profit",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:OtherIncome",
      "label": "Other income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-full:OtherIncome"
        }
      }
    },
    {
      "qname": "ssmt-mfrs:SellingAndDistributionExpenses",
      "label": "(-) Selling and distribution expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:AdministrativeExpense",
      "label": "(-) Administrative expenses",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:ResearchAndDevelopmentExpense",
      "label": "(-) Research and development expense",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:OtherExpenseByFunction",
      "label": "(-) Other expenses",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-full:OtherExpenseByFunction"
        }
      }
    },
    {
      "qname": "ifrs-full:ProfitLossFromOperatingActivities",
      "label": "Profit (loss) from operating activities",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:FinanceIncome",
      "label": "Finance income",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "310100",
          "qname": "ifrs-full:FinanceIncome"
        }
      }
    },
    {
      "qname": "ifrs-full:FinanceCosts",
      "label": "(-) Finance costs",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:ShareOfProfitLossOfAssociatesAndJointVenturesAccountedForUsingEquityMethod",
      "label": "Share of profit (loss) of associates and joint ventures accounted for using equity method",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mfrs:FairValuationGainLossArisingFromDistributionOfNoncashAssetsToOwners",
      "label": "Fair valuation gain (loss) arising from distribution of non-cash assets to owners",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:ProfitLossBeforeTax",
      "required": true,
      "label": "Profit (loss) before tax",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfCashFlowsIndirectMethod",
            "field": "ifrs-full:ProfitLossBeforeTax"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:IncomeTaxExpenseContinuingOperations",
      "label": "(-) Tax expense",
      "type": "MonetaryItemType",
      "required": true,
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ssmt-mfrs:ContributionOfZakat",
      "label": "(-) Contribution of zakat",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:ProfitLossFromContinuingOperations",
      "required": true,
      "label": "Profit (loss) from continuing operations",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ssmt-mfrs:DiscontinuedOperationsAbstract",
      "label": "Discontinued operations",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ProfitLossFromDiscontinuedOperations",
      "label": "Profit (loss) from discontinued operations, net of tax",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:ProfitLoss",
      "required": true,
      "label": "Profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "410000",
          "qname": "ifrs-full:ProfitLoss"
        }
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-full:ProfitLoss_2"
          },
          {
            "sheet": "statementOfChangesInEquity",
            "field": "ifrs-full:ProfitLoss"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:ProfitLossAttributableToAbstract",
      "label": "Profit (loss), attributable to",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:ProfitLossAttributableToOwnersOfParent",
      "label": "Profit (loss), attributable to owners of parent",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      },
      "requiredIf": {
        "sheet": "filingPrerequisites",
        "field": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements",
        "equals": "Consolidated",
        "errorMessage": "When \"Nature of Financial Statements\" is \"Consolidated\", then \"Profit (loss), attributable to owners of parent\" MUST be reported."
      }
    },
    {
      "qname": "ssmt-mfrs:ProfitLossAttributableToOtherComponentsOfEquity",
      "label": "Profit (loss) attributable to equity other components",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:ProfitLossAttributableToNoncontrollingInterests",
      "label": "Profit (loss), attributable to non-controlling interests",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      },
      "requiredIf": {
        "sheet": "filingPrerequisites",
        "field": "ssmt-dei-ee-mfrs:NatureOfFinancialStatements",
        "equals": "Consolidated",
        "errorMessage": "When \"Nature of Financial Statements\" is \"Consolidated\", then \"Profit (loss), attributable to non-controlling interests\" MUST be reported."
      }
    },
    {
      "qname": "ifrs-full:ProfitLoss_2",
      "required": true,
      "label": "Total Profit (loss)",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true,
        "linkTo": {
          "role": "410000",
          "qname": "ifrs-full:ProfitLoss"
        }
      },
      "validation": {
        "dataType": "decimal",
        "equality": [
          {
            "sheet": "statementOfProfitOrLoss",
            "field": "ifrs-full:ProfitLoss"
          }
        ]
      }
    },
    {
      "qname": "ifrs-full:EarningsPerShareAbstract",
      "label": "Earnings per share",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 2,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:BasicEarningsPerShareAbstract",
      "label": "Basic earnings per share",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:BasicEarningsLossPerShareFromContinuingOperations",
      "label": "Basic earnings (loss) per share from continuing operations",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:BasicEarningsLossPerShareFromDiscontinuedOperations",
      "label": "Basic earnings (loss) per share from discontinued operations",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:BasicEarningsLossPerShare",
      "label": "Total basic earnings (loss) per share",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    },
    {
      "qname": "ifrs-full:DilutedEarningsPerShareAbstract",
      "label": "Diluted earnings per share",
      "type": "SectionHeader",
      "ui": {
        "controlType": "section-header",
        "level": 3,
        "dualColumn": true
      }
    },
    {
      "qname": "ifrs-full:DilutedEarningsLossPerShareFromContinuingOperations",
      "label": "Diluted earnings (loss) per share from continuing operations",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:DilutedEarningsLossPerShareFromDiscontinuedOperations",
      "label": "Diluted earnings (loss) per share from discontinued operations",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": false,
        "calculated": false
      }
    },
    {
      "qname": "ifrs-full:DilutedEarningsLossPerShare",
      "label": "Total diluted earnings (loss) per share",
      "type": "MonetaryItemType",
      "ui": {
        "controlType": "number",
        "dualColumn": true,
        "readonly": true,
        "calculated": true
      }
    }
  ]
}
